import { render } from "./HistoryTab.vue?vue&type=template&id=3ca2de05&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"

import "./HistoryTab.vue?vue&type=style&index=0&id=3ca2de05&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca2de05"]])

export default __exports__